const state = {
  widgets: [
    {
      title: 'Param High',
      severity: 1,
      count: 23,
    },
    {
      title: 'Param Low',
      severity: 3,
      count: 3,
    },
    {
      title: 'Event Alarm',
      severity: 2,
      count: 10,
    },
  ],
}

const getters = {
  allWidgets: state => state.widgets,
}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
